export default __webpack_public_path__ + "static/media/paper-plane.f6e0e547.svg";